import React from 'react';

const Spacer = () => {
  return <div className="mb-5"></div>;
};

export default Spacer;